import React from 'react'
import { RadioButtonUnchecked } from '@material-ui/icons'

import { MultipleChoiceInactiveProps } from './multipleChoiceInactive.types'
import * as S from './../../fieldsInactive.styles'

export const MultipleChoiceInactive = ({ item, ...props }: MultipleChoiceInactiveProps) => {
    return (
        <S.FieldInactiveWrapper {...props}>
            <S.Header>
                <S.Title>{item.value}</S.Title>

                {item.required && <S.Required>*Required</S.Required>}
            </S.Header>

            <S.OptionsList>
                {item.options.map((option) => (
                    <S.OptionsListItem key={option.id}>
                        <RadioButtonUnchecked />
                        {option.value}
                    </S.OptionsListItem>
                ))}

                {item.hasOther && (
                    <S.OptionsListItem>
                        <RadioButtonUnchecked />
                        Other
                    </S.OptionsListItem>
                )}
            </S.OptionsList>
        </S.FieldInactiveWrapper>
    )
}
